import { create } from 'zustand';

type State = {
  modalMaskOpen: boolean;
  modalMaskText: string;
  openModalMask: (text?: string) => void;
  closeModalMask: () => void;
};

export const useModalStore = create<State>((set) => ({
  modalMaskOpen: false,
  modalMaskText: '',
  openModalMask: (text) => set({ modalMaskOpen: true, modalMaskText: text || '' }),
  closeModalMask: () => set({ modalMaskOpen: false, modalMaskText: '' }),
}));
